import { useEffect, useState } from "react";

const HouseBeforeContent = () => {
  const COLORS = {
    primaryGreen: "#5ec250",
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const styles = {
    container: {
      maxWidth: "1100px",
      margin: "0 auto",
      padding: isMobile ? "40px 16px" : "60px 20px",
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      overflowX: "hidden",
    },

    title: {
      textAlign: "center",
      fontSize: "clamp(26px, 4vw, 44px)",
      fontWeight: 500,
      lineHeight: 1.2,
      marginBottom: isMobile ? "30px" : "50px",
    },

    highlight: { color: COLORS.primaryGreen },

    /* ================= SECTION 1 ================= */
    sectionOne: {
      display: "flex",
      gap: "40px",
      flexWrap: "wrap",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
    },

    leftImageWrap: {
      flex: "1 1 420px",
      display: "flex",
      justifyContent: "center",
    },

    imageStack: {
      position: "relative",
      width: "100%",
      maxWidth: isMobile ? "280px" : "420px",
    },

    imageTiltShade: {
      position: "absolute",
      top: isMobile ? "8px" : "12px",
      left: isMobile ? "15px" : "36px",
      transform: isMobile ? "rotate(2deg)" : "rotate(5deg)",
      width: "100%",
      height: isMobile ? "84%" : "100%",
      background: "#e5e5e5",
      borderRadius: "38px",
      zIndex: 0,
    },

    leftImage: {
      position: "relative",
      width: "100%",
      borderRadius: "35px",
      zIndex: 1,
    },

    rightContent: {
      marginTop: isMobile ? "-65px" : "",
      flex: "1 1 480px",
      display: "flex",
      flexDirection: "column",
      textAlign: isMobile ? "center" : "left",
    },

    description: {
      fontSize: isMobile ? "16px" : "20px",
      lineHeight: 1.8,
      color: "#555",
      marginBottom: "25px",
    },

    bottomRow: {
      display: "flex",
      gap: "20px",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
    },

    highlightCard: {
      background: "#3b3b3b",
      color: "#fff",
      padding: "20px",
      borderRadius: "16px",
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: 1.6,
      width: isMobile ? "88%" : "100%",
    },

    smallImage: {
      width: isMobile ? "100%" : "200px",
      maxWidth: "320px",
      borderRadius: "16px",
      objectFit: "cover",
    },

    /* ================= SECTION 2 ================= */
    sectionTwo: {
      display: "flex",
      gap: "40px",
      marginTop: "50px",
      flexWrap: "wrap",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
    },

    modernLeft: {
      flex: "1 1 420px",
      display: "flex",
      flexDirection: "column",
      gap: "18px",
      textAlign: isMobile ? "center" : "left",
    },

    modernTitle: {
      fontSize: isMobile ? "22px" : "26px",
      fontWeight: 500,
      lineHeight: 1.3,
    },

    modernLeftCard: {
      background: "#f1fbf4",
      borderRadius: "22px",
      padding: "18px",
    },

    modernImage: {
      width: "100%",
      borderRadius: "18px",
      marginBottom: "14px",
    },

    modernCaption: {
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: 1.6,
      color: "#333",
    },

    modernRight: {
      flex: "1 1 520px",
      display: "flex",
      flexDirection: "column",
      textAlign: isMobile ? "center" : "left",
    },

    modernDesc: {
      fontSize: isMobile ? "16px" : "20px",
      lineHeight: 1.7,
      color: "#555",
      marginBottom: "26px",
    },

    featureGrid: {
      display: "grid",
      gridTemplateColumns: isMobile
        ? "repeat(auto-fit, minmax(140px, 1fr))"
        : "repeat(2, 1fr)",
      gap: "16px",
      justifyItems: "center",
      marginBottom: "28px",
    },

    listItem: {
      fontSize: isMobile ? "15px" : "17px",
      color: "#444",
      lineHeight: 1.7,
    },

    footerText: {
      fontSize: isMobile ? "16px" : "20px",
      lineHeight: 1.7,
      color: "#555",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>
        House for Sale in Trichy with Premium Amenities
      </h1>

      {/* SECTION 1 */}
      <div style={styles.sectionOne}>
        <div style={styles.leftImageWrap}>
          <div style={styles.imageStack}>
            <div style={styles.imageTiltShade} />
            <img
              src="https://mithahomes.com/backend/uploads/home/image2.png"
              alt="House for Sale in Trichy"
              style={styles.leftImage}
            />
          </div>
        </div>

        <div style={styles.rightContent}>
          <p style={styles.description}>
            Looking for a house for sale in Trichy that offers comfort, quality, and long-term value? Mitha Homes brings you thoughtfully designed residential properties in some of the city’s most sought-after locations. Whether you are searching for an independent house, a villa, or a modern home within a gated community, we provide options that suit different lifestyles and budgets. <br /><br />
            With Trichy rapidly growing as a residential and investment destination, owning a home here ensures both peaceful living and strong future appreciation
          </p>
          <div style={styles.bottomRow}>
            <div style={styles.highlightCard}>
              <strong>Mitha Homes best option for luxury houses -</strong><br /><br />
              -	Focus is on customer satisfaction<br />
              Mitha Homes is a trusted name in Trichy’s real estate market, known for delivering high-quality residential projects. Our focus is on customer satisfaction, timely delivery, and transparent processes.
              We ensure that every home we build meets the expectations of modern homebuyers in terms of design, durability, and value.
            </div>

            <img
              src="https://mithahomes.com/backend/uploads/home/image3.png"
              alt="House Building Trichy"
              style={styles.smallImage}
            />
          </div>
        </div>
      </div>

      {/* SECTION 2 */}
      <div style={styles.sectionTwo}>
        <div style={styles.modernLeft}>
          <h2 style={styles.modernTitle}>
            3 BHK Houses in Trichy –{" "}
            <span style={{ color: COLORS.primaryGreen }}>
              Book your dream home today
            </span>
          </h2>

          <div style={styles.modernLeftCard}>
            <img
              src="https://mithahomes.com/backend/uploads/home/image4.png"
              alt="House Project Trichy"
              style={styles.modernImage}
            />
            <p style={styles.modernCaption}>
              <strong>Not Just a House… It’s Where Life Happens</strong><br />From morning coffee on your balcony to family moments that turn into memories, your home is more than just walls—it’s your story. Mitha Homes brings you thoughtfully crafted houses in Trichy where comfort meets happiness.
            </p>
          </div>
        </div>

        <div style={styles.modernRight}>
          <p style={styles.modernDesc}>
            <strong>Live the Life You’ve Always Imagined</strong><br />
            Enjoy wide spaces, fresh air, and a calm environment away from city chaos—without losing connectivity. Our homes are designed for modern families who want both comfort and convenience.
          </p>

          <div style={styles.featureGrid}>
            <div style={styles.listItem}>• Prime locations across Trichy</div>
            <div style={styles.listItem}>• Smartly designed spacious homes</div>
            <div style={styles.listItem}>• Quality construction you can trust</div>
            <div style={styles.listItem}>• Peaceful, family-friendly neighborhoods</div>
            <div style={styles.listItem}>• Great value for your investment</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HouseBeforeContent;
